import { PlayCircle, CheckCircle, XCircle, Calendar, FileCheck, AlertTriangle } from 'lucide-react';
import type { AssignmentStatus } from '../types';


export const ASSIGNMENT_STATUS_CONFIG: Record<AssignmentStatus, { label: string; color: string; icon: any }> = {
    pending: {
        label: 'En attente',
        color: 'bg-yellow-500/15 text-yellow-500 border-yellow-500/20',
        icon: AlertTriangle
    },
    todo: {
        label: 'Planifié',
        color: 'bg-orange-500/15 text-orange-500 border-orange-500/20',
        icon: Calendar
    },
    'in-progress': {
        label: 'En cours',
        color: 'bg-blue-500/15 text-blue-500 border-blue-500/20',
        icon: PlayCircle
    },
    'in_progress': {
        label: 'En cours',
        color: 'bg-blue-500/15 text-blue-500 border-blue-500/20',
        icon: PlayCircle
    },
    'completed-by-tech': {
        label: 'Terminé',
        color: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/20',
        icon: CheckCircle
    },
    closed: {
        label: 'Clôturé',
        color: 'bg-slate-500/15 text-slate-400 border-slate-500/20',
        icon: FileCheck
    },
    done: {
        label: 'Terminé',
        color: 'bg-emerald-500/15 text-emerald-500 border-emerald-500/20',
        icon: CheckCircle
    },
    blocked: {
        label: 'Bloqué',
        color: 'bg-red-500/15 text-red-500 border-red-500/20',
        icon: XCircle
    }
};
